import { connect } from 'react-redux';
import References from './references';
import getPdfViewerApplication from '../../utils/pdfjs/pdfViewerApplication';
import { goToNextReference, goToPrevReference } from '../../../shared/actions/navigateUtils';
import { referenceType as referenceTypeConstant } from '../../../shared/constants';

const referenceType = referenceTypeConstant.bibliography;
const query = { referenceType };

const mapStateToProps = (state) => {
  const { references } = state;
  const { enhancementManager } = getPdfViewerApplication();
  const { reference, labels } = enhancementManager.getActiveReference(query);
  const hasNext = enhancementManager.referencesAfter(query);
  const hasPrev = enhancementManager.referencesBefore(query);

  return {
    hasNext,
    hasPrev,
    labels,
    reference,
    referencesCount: references.data.length,
  };
};

const mapDispatchToProps = dispatch => ({
  goToNext: () => dispatch(goToNextReference(referenceType)),
  goToPrev: () => dispatch(goToPrevReference(referenceType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(References);
